import {formatDisplayPrice} from "../../../../../../res/dataServices/pricing";
import errorReportRequest from "../../../../../services/rest/request/error/errorReportRequest";

const reportUnrecognisedCartMessage = async (svrMessage) => {
    void errorReportRequest()
        .tag("Unrecognised Checkout Error Message")
        .message(svrMessage)
        .url("checkout")
        .sendIt(1);
}

const getMessageFromError = (error) => {
    if(error?.message) {
        return error.message;
    } if(error?.data?.detail){
        return error.data.detail;
    } else {
        return null;
    }
}

const getCheckoutError = (error, prefix) => {
    console.log("in checkout ", error);
    const message = getMessageFromError(error);

    const reportIt = () => {
        const toReport = message ? message : error;
        try {
            void reportUnrecognisedCartMessage(toReport);
        } catch (e) {}
    }

    if(message) {
        if(message.includes("Minimum Order Value Not Reached")) {
            return prefix + message;
        }
        else if (message.includes("No live mandate for Direct Debit")) {
            return "We could not find a live Direct Debit Mandate";
        }


        else {
            reportIt();
            return prefix + message;
        }
    } else {
        reportIt();
        return prefix + "Unknown Error";
    }

}

const getCartErrorMessage = (cart) => {

    if(cart.error.prepare) {
        const msg = getCheckoutError(cart.error.prepare, "An issue occurred preparing your order, message: ");
        return ["Issue preparing order", msg];
    }

    if(cart.error.checkout) {
        const msg = getCheckoutError(cart.error.checkout, "An issue occurred completing your order, message: ");
        return ["Issue completing order", msg];
    }
}

const getCartFunctions = (cart) => {
    const functions = {};

    functions.isCartEmpty = () => {
        return !cart?.loadingCart && cart.lines && Object.keys(cart.lines).length === 0;
    }
    functions.isOrderComplete = () => {
        return !cart?.loadingCart && cart.order && cart.order.DocStatus.id === 'CO';
    }
    functions.isCartLoading = () => {
        return cart.loadingCart;
    }
    functions.isOrderLoading = () => {
        return cart.loadingOrder;
    }
    functions.isCheckoutLoading = () => {
        return (cart.loading.prepare || cart.loading.checkout);
    }
    functions.isOrderDetailThere = () => {
        return Boolean(cart.order);
    }

    functions.getOrderID = () => {
        return cart?.id;
    }
    functions.getDocumentNo = () => {
        return cart?.order?.DocumentNo
    }
    functions.getReference = () => {
        return cart?.order?.POReference;
    }
    functions.getPromotionCode = () => {
        return cart?.order?.PromotionCode;
    }
    functions.getDeliveryNote = () => {
        return cart?.order?.X_DeliveryNote;
    }
    functions.getBPartner = () => {
        return cart?.order?.C_BPartner_ID;
    }
    functions.getBPartnerID = () => {
        return functions.getBPartner().id;
    }
    functions.getBPartnerLocation = () => {
        return cart?.order?.C_BPartner_Location_ID;
    }
    functions.getBPartnerLocationID = () => {
        return functions.getBPartnerLocation()?.id;
    }
    functions.getDeliveryViaRule = () => {
        return cart?.order?.DeliveryViaRule?.id;
    }
    functions.getDatePromised = () => {
        return cart?.order?.DatePromised ? new Date(cart.order.DatePromised) : null;
    }
    functions.getPaymentType = () => {
        return cart?.order?.PaymentRule?.id;
    }
    functions.getDateOrdered = () => {
        return cart?.order?.DateOrdered ? new Date(cart.order.DateOrdered) : null;
    }

    functions.getGuidePrice = () => {
        return formatDisplayPrice(cart?.getProductTotal());
    }

    functions.getCheckoutError = () => {
        return getCartErrorMessage(cart);
    }

    return functions;
}

export default getCartFunctions;
